import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Events", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_helper_table = _resolveComponent("helper-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_helper_dialog = _resolveComponent("helper-dialog")!

  return (_openBlock(), _createBlock(_component_helper_dialog, {
    width: "800",
    ref: "helperDialogRef",
    onClosed: _ctx.handleDialogClosed
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(({ dialogOpen }) => [
      dialogOpen
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.tabs,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabs) = $event)),
              type: "border-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  name: _ctx.Tab.content,
                  label: "MapEvent content"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _ctx.content[_ctx.locale]
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }, 8, ["name"]),
                _createVNode(_component_el_tab_pane, {
                  name: _ctx.Tab.travellers,
                  label: "Impacted travellers"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, { size: "default" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.radius,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radius) = $event)),
                                      teleported: true,
                                      clearable: "",
                                      placeholder: "Radius"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['5', '10', '30'], (item, index) => {
                                          return _createVNode(_component_el_option, {
                                            key: index,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: _ctx.wholeCountry,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wholeCountry) = $event)),
                                      label: "Whole country"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.tabs === _ctx.Tab.travellers)
                      ? (_openBlock(), _createBlock(_component_helper_table, {
                          key: 0,
                          data: _ctx.tableData,
                          columns: _ctx.tableColumns,
                          size: "small"
                        }, null, 8, ["data", "columns"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["name"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(({ close }) => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: close
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClosed"]))
}